import { AddNotePopupComponent } from './../components/consultation-progress-bar/add-note-popup.component';
import { CurrencyNumberDirective } from './../directives/currency-number.directive';
import { CurrencyNumberPipe } from './../pipes/currency-number.pipe';
import { RouterModule } from '@angular/router';
import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentModule } from 'angular2-moment';
import { BrowserModule } from '@angular/platform-browser';
import { MenuItems } from './menu-items/menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { FormLabelComponent } from '../components/form/label/label.component';
import { FormMessageComponent } from '../components/form/message/message.component';
import {
  MdDialogModule,
  MdCheckboxModule,
  MdRadioModule,
  MdTableModule,
  MdButtonModule,
  MdPaginatorModule,
  MdTabsModule,
  MdInputModule,
  MdSelectModule,
  MdTooltipModule,
  MdDatepickerModule,
  MdNativeDateModule } from '@angular/material';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ConsultationProGressBarComponent } from '../components/consultation-progress-bar/consultation-progress-bar.component';
import { OnlyNumber } from '../directives/onlynumber.directive';
import { DateTimePickerDirective } from '../directives/datepicker.directive';
import { QuillEditorModule } from 'ngx-quill-editor';
@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    FormLabelComponent,
    FormMessageComponent,
    ConsultationProGressBarComponent,
    OnlyNumber,
		CurrencyNumberPipe,
    CurrencyNumberDirective,
    AddNotePopupComponent,
    DateTimePickerDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdCheckboxModule,
    MdTableModule,
    MdButtonModule,
    MdPaginatorModule,
    MdTabsModule,
    MdInputModule,
    MdDialogModule,
    MdRadioModule,
    MdTooltipModule,
    MdSelectModule,
    NgxDatatableModule,
    MdDatepickerModule,
    MdNativeDateModule,
    RouterModule,
    MomentModule,
    QuillEditorModule
    
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdCheckboxModule,
    MdTableModule,
    MdButtonModule,
    MdPaginatorModule,
    MdTabsModule,
    MdInputModule,
    MdDialogModule,
    MdRadioModule,
    MdTooltipModule,
    MdSelectModule,
    NgxDatatableModule,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    FormLabelComponent,
    FormMessageComponent,
    ConsultationProGressBarComponent,
    MdDatepickerModule,
    MdNativeDateModule,
    OnlyNumber,
		CurrencyNumberPipe,
    CurrencyNumberDirective,
    DateTimePickerDirective
  ],
  entryComponents: [AddNotePopupComponent],
  providers: [MenuItems],
})
export class SharedModule { }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/shared.module.ts